const componentStyleMargin = '30px auto 50px';
export const styliticsConfig = {
	dsg: {
		name: 'dickssportinggoods',
		bundles: {
			componentStyle: {
				margin: componentStyleMargin
			},
			componentClassesToAdd: '',
			componentClassesToRemove: ''
		},
		nonBundles: {
			componentStyle: {
				margin: '0px'
			},
			componentClassesToAdd: '',
			componentClassesToRemove: ''
		}
	},
	gg: {
		name: 'golfgalaxy',
		bundles: {
			componentStyle: {
				margin: componentStyleMargin
			},
			componentClassesToAdd: '',
			componentClassesToRemove: ''
		},
		nonBundles: {
			componentStyle: {
				margin: '0px'
			},
			componentClassesToAdd: '',
			componentClassesToRemove: ''
		}
	},
	pl: {
		name: 'publiclands',
		bundles: {
			componentStyle: {
				margin: componentStyleMargin
			},
			componentClassesToAdd: '',
			componentClassesToRemove: ''
		},
		nonBundles: {
			componentStyle: {
				margin: '0px',
				backgroundColor: 'transparent'
			},
			componentClassesToAdd: '',
			componentClassesToRemove: 'hmf-py-l'
		}
	}
};
